import afterChangeResources from './afterChangeResources';

export default {
  afterChangeResources,
};
